import React,{useEffect, useState} from 'react'
import { useParams } from 'react-router-dom'
import { useTranslation } from "react-i18next"
import { Container, Button, Row} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { getMachineryDetail, addMachinery, getMachineries } from '../../../actions/machineriesActions'
import FormMachinery from '../../admin/machineries/FormMachinery'
import Swal from 'sweetalert2'

export default function MachineryInsert() {     
    const { t } = useTranslation()
    const {id} = useParams()
    const {machinery} = useSelector(state=>state.machineries)
    const dispatch = useDispatch()

    const [formState, setFormState] = useState({})
    const {plate, name, description, type, chassis, roma, year, check} = formState

    const handleInputChange = ({target})=>{
        setFormState({
            ...formState,
            [target.name]: target.value
        })
    }

    const handleAdd = async(e) => {
        e.preventDefault()

        dispatch(addMachinery(plate, name, description, type, chassis, roma, year, check))
        setFormState({
            plate: '',
            name: '',
            description: '',
            type: '',
            chassis: '',
            roma: '',
            year: '',
            check: ''
        })
        
        Swal.fire({
            showConfirmButton: true,
            icon: 'success',
            text: t('machineries.messageadd')
        })
    }

    useEffect(()=>{
        dispatch(getMachineryDetail(id))
        dispatch(getMachineries())
    }, [dispatch,id])

    useEffect(() => {
        if (machinery) {
            setFormState({
                plate: '',
                name: '',
                description: '',
                type: '',
                chassis: '',
                roma: '',
                year: '',
                check: ''
            })
        }
    }, [machinery, dispatch, id])
  
    return (
        <Container className='cuerpo'>
            <Row className="text-left custom-card-header-list">
                <Row className="custom-card-buttom">
                    <Button className="btn btn-secondary mb-4 mx-auto" href={`/admin/machineries`}>
                        <i className="fas fa-arrow-circle-left"></i> {t('machineries.volver')}
                    </Button>
                </Row>
                <h1>{t('machineries.add')}</h1>
                <FormMachinery submit={handleAdd} isNew={true} inputChange={handleInputChange} state={formState}></FormMachinery>
            </Row>
        </Container>
    )
}
